module.exports = __webpack_public_path__ + "img/胡椒.138a7841.jpg";